/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Copilot_Sugglesson1Inputs */

const zh_landing_copilot_sugglesson1 = /** @type {(inputs: Landing_Copilot_Sugglesson1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`教案设计`)
};

const en_landing_copilot_sugglesson1 = /** @type {(inputs: Landing_Copilot_Sugglesson1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesson Planning`)
};

const es_landing_copilot_sugglesson1 = /** @type {(inputs: Landing_Copilot_Sugglesson1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planificación de lecciones`)
};

/**
* | output |
* | --- |
* | "Lesson Planning" |
*
* @param {Landing_Copilot_Sugglesson1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_copilot_sugglesson1 = /** @type {((inputs?: Landing_Copilot_Sugglesson1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Copilot_Sugglesson1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_copilot_sugglesson1(inputs)
	if (locale === "en") return en_landing_copilot_sugglesson1(inputs)
	return es_landing_copilot_sugglesson1(inputs)
});
export { landing_copilot_sugglesson1 as "landing_copilot_suggLesson" }